import type { ReactNode } from 'react';

import { Container } from '@/components/ui';

/**
 * Смуга тестового стенда. Мітку задає збірка (`VITE_ENV_LABEL`), тож у
 * продакшн-бандлі її немає зовсім. Без неї тестувальник сприймає знімок
 * аукціонів як живий каталог і пише в чат, що лоти «застарілі».
 */
export function EnvBanner(): ReactNode {
	const label = import.meta.env.VITE_ENV_LABEL?.trim();
	if (!label) return null;
	return (
		<div role="note" className="bg-warning/15 text-warning-strong">
			<Container className="py-1.5 text-center text-xs leading-4 font-medium">
				<span className="font-semibold">{label}</span> — auction data is a snapshot; bids and payments are not real.
			</Container>
		</div>
	);
}
